

const ContactUs = () => {
  return (
    <>
      <div className="padding-65">
        <div className="row">
          <div className="col-md-6 mt-2">
            <h5 className="fw-bold">Contact Us</h5>
          </div>
          <div className="col-md-6 text-end mt-1">
            <input
              className="form-control bg-body-secondary w-75 h-100 rounded fw-medium px-3 p-0"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
          </div>
        </div>
      </div>
      <div className="padding-50">
        <div className="container-fluid">
          <table className="booking-table table table-striped">
            <thead className="fw-semibold">
              <tr>
                <th style={{ padding: "15px 2px 22px 20px;" }}>Name</th>
                <th style={{ padding: "15px 2px 22px 10px;" }}>Email</th>
                <th style={{ padding: "15px 2px 22px 10px;" }}>Phone</th>
                <th style={{ padding: "15px 2px 22px 10px;" }}>Note</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "15px 2px 22px 20px;" }}>Hitendra</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>Hitu@gmail.com</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>1234567890</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>Wow</td>
              </tr>
              <tr>
                <td style={{ padding: "15px 2px 22px 20px;" }}>Ankit Kumar</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>ankit@gmail.com</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>1234567890</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>Wow</td>
              </tr>
              <tr>
                <td style={{ padding: "15px 2px 22px 20px;" }}>vinayak sharan</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>vsharan@gmail.com</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>1234567890</td>
                <td style={{ padding: "15px 2px 22px 10px;" }}>Wow</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ContactUs;